import { render } from "./Admin.ShopOrders.ListDatatable.vue?vue&type=template&id=c9c306ce"
import script from "./Admin.ShopOrders.ListDatatable.vue?vue&type=script&lang=js"
export * from "./Admin.ShopOrders.ListDatatable.vue?vue&type=script&lang=js"

import "./Admin.ShopOrders.ListDatatable.vue?vue&type=style&index=0&id=c9c306ce&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__